import { Component, ViewEncapsulation } from "@angular/core";
import { QbHealthService } from "./qb-health.service";

/**
 * Banner shown at the top of any page that gates actions on QuickBooks connectivity.
 * Renders a spinner while the check is running, a red error block when QBO is unhealthy,
 * and nothing when healthy. Bind action buttons on the page to
 * `qbHealth.isQbHealthy && !qbHealth.isCheckingQb`.
 */
@Component({
  selector: "uni-qb-health-banner",
  template: `
    <div
      *ngIf="qbHealth.isCheckingQb"
      class="m-2 flex items-center gap-2 rounded border border-blue-300 bg-blue-50 p-3 text-sm text-blue-800"
    >
      <i class="pi pi-spinner pi-spin"></i>
      <span>Checking QuickBooks connection&hellip;</span>
    </div>
    <div
      *ngIf="!qbHealth.isCheckingQb && qbHealth.qbHealthMessage"
      class="m-2 rounded border border-red-300 bg-red-50 p-3 text-sm text-red-800"
    >
      <div class="mb-1 font-semibold">QuickBooks is not connected — all actions are disabled.</div>
      <div [innerHTML]="qbHealth.qbHealthMessage" class="whitespace-pre-line"></div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class QbHealthBannerComponent {
  constructor(public qbHealth: QbHealthService) {}
}
